import P from 'components/atoms/P'
import styled from 'styled-components/macro'

const Content = styled(P)`
  width: 80%;
  color: inherit;
`

export default Content
